
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// PrimeNG Imports
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { Editor, EditorModule } from 'primeng/editor';
import { ButtonModule } from 'primeng/button';
import { templateTypes, TemplateType, LinkedInTemplate } from '../../../models/linkedin.model';


@Component({
  selector: 'app-new-linkedin-template',
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    DropdownModule,
    EditorModule,
    ButtonModule
  ],
  standalone: true,
  templateUrl: './new-linkedin-template.component.html',
  styleUrl: './new-linkedin-template.component.scss'
})
export class NewLinkedinTemplateComponent implements OnInit {
  @ViewChild('contentEditor') editor?: Editor;
  @Input()
  completeCallback?: (data: any) => void;
  @Input()
  cancelCallback?: () => void;
  @Input()
  template: LinkedInTemplate | null = null;
  @Input()
  isCopyTemplate: boolean = false;

  templateName: string = '';
  selectedTemplateType: TemplateType | null = null;
  templateContent: string = '';
  maxContentLength: number = 1900;
  templateTypes: TemplateType[] = []


  constructor() {
    this.templateTypes = templateTypes;
    // Set default selection to Message
    this.selectedTemplateType = this.templateTypes[0];
  }
  ngOnInit(): void {
    if (this.template) {
      console.log(this.template);

      this.templateName = this.template.name;
      this.templateContent = this.template.content;
      //@ts-ignore
      this.selectedTemplateType = templateTypes.find(e => e.value == this.template.type);
    }
  }

  get contentCharacterCount(): number {
    const quill = this.editor?.getQuill();
    if (quill) {
      return quill.getText().trim().length;
    }
    return this.templateContent.length;
  }

  insertPersonalizationVariable(variable: string): void {
    const quill = this.editor?.getQuill();
    if (quill) {
      const selection = quill.getSelection() || { index: quill.getLength(), length: 0 };
      quill.insertText(selection.index, `{{${variable}}}`);
    }
  }

  onCancel(): void {
    // Handle cancel action
    console.log('Cancel clicked');
    this.template = null;
    //@ts-ignore
    this.cancelCallback()
  }

  onCreateTemplate(): void {
    // Handle create template action
    const quill = this.editor?.getQuill();
    const plainText = quill ? quill.getText().trim() : this.templateContent;
    const htmlContent = quill ? quill.root.innerHTML : this.templateContent;

    let templateData;
    if (this.template?.id && !this.isCopyTemplate) {
      templateData = {
        id: this.template.id,
        name: this.templateName,
        type: this.selectedTemplateType?.value,
        content: plainText,
        contentHtml: htmlContent,
        provider: 'linkedin',
        action: 'update'
      };
    } else {
      templateData = {
        name: this.templateName,
        type: this.selectedTemplateType?.value,
        content: plainText,
        contentHtml: htmlContent,
        provider: 'linkedin'
      };
    }
    console.log('Create template clicked', templateData);
    this.template= null;
    //@ts-ignore
    this.completeCallback(templateData)
  }

}
